"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _FirstClause = _interopRequireDefault(require("./FirstClause"));
var _SecondClause = _interopRequireDefault(require("./SecondClause"));
var _ThirdClause = _interopRequireDefault(require("./ThirdClause"));
var _FourthClause = _interopRequireDefault(require("./FourthClause"));
var _FifthClause = _interopRequireDefault(require("./FifthClause"));
var _SixthClause = _interopRequireDefault(require("./SixthClause"));
var _SeventhClause = _interopRequireDefault(require("./SeventhClause"));
var _EighthClause = _interopRequireDefault(require("./EighthClause"));
var _NinthClause = _interopRequireDefault(require("./NinthClause"));
var _TenthClause = _interopRequireDefault(require("./TenthClause"));
var _EleventhClause = _interopRequireDefault(require("./EleventhClause"));
var _TwelfthClause = _interopRequireDefault(require("./TwelfthClause"));
var _ThirteenthClause = _interopRequireDefault(require("./ThirteenthClause"));
var _FourteenthClause = _interopRequireDefault(require("./FourteenthClause"));
var _FifteenthClause = _interopRequireDefault(require("./FifteenthClause"));
var _SixteenthClause = _interopRequireDefault(require("./SixteenthClause"));
/**
 * @param {{
 *     emailDomain: string;
 * }} props
 */
function AllClauses(_ref) {
  var emailDomain = _ref.emailDomain;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "TermsAndConditions-container-columnRight-clauses"
  }, /*#__PURE__*/_react["default"].createElement(_FirstClause["default"], null), /*#__PURE__*/_react["default"].createElement(_SecondClause["default"], null), /*#__PURE__*/_react["default"].createElement(_ThirdClause["default"], null), /*#__PURE__*/_react["default"].createElement(_FourthClause["default"], null), /*#__PURE__*/_react["default"].createElement(_FifthClause["default"], null), /*#__PURE__*/_react["default"].createElement(_SixthClause["default"], null), /*#__PURE__*/_react["default"].createElement(_SeventhClause["default"], null), /*#__PURE__*/_react["default"].createElement(_EighthClause["default"], null), /*#__PURE__*/_react["default"].createElement(_NinthClause["default"], null), /*#__PURE__*/_react["default"].createElement(_TenthClause["default"], null), /*#__PURE__*/_react["default"].createElement(_EleventhClause["default"], {
    emailDomain: emailDomain
  }), /*#__PURE__*/_react["default"].createElement(_TwelfthClause["default"], {
    emailDomain: emailDomain
  }), /*#__PURE__*/_react["default"].createElement(_ThirteenthClause["default"], {
    emailDomain: emailDomain
  }), /*#__PURE__*/_react["default"].createElement(_FourteenthClause["default"], {
    emailDomain: emailDomain
  }), /*#__PURE__*/_react["default"].createElement(_FifteenthClause["default"], null), /*#__PURE__*/_react["default"].createElement(_SixteenthClause["default"], null));
}
var _default = AllClauses;
exports["default"] = _default;